import { X } from "lucide-react";

/**
 * Full-screen lightbox for inspecting an attached message image.
 * Click outside the image (overlay) or the close button to dismiss.
 */
export default function ImageLightbox({ imageUrl, onClose }) {
  if (!imageUrl) return null;

  return (
    <div
      className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="image-lightbox"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white"
        data-testid="close-lightbox-btn"
      >
        <X className="w-6 h-6" />
      </button>
      <img
        src={imageUrl}
        alt="Full size"
        className="max-w-full max-h-full object-contain rounded-lg"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
